module.exports = __webpack_public_path__ + "static/media/anteiaTik.985c73b4.mp4";